import React from "react";
import { ModalBuilder, Modal, Form, useFormField } from "@redriver/cinnamon";
import { Button, Grid } from "semantic-ui-react";

const fields = [
  { ref: "app", toggle: "Filter app", entry: "App ref" },
  { ref: "env", toggle: "Filter environment", entry: "Environment" },
  { ref: "machine", toggle: "Filter machine", entry: "Hostname" },
  { ref: "role", toggle: "Filter role", entry: "Role name" },
  {
    ref: "level",
    toggle: "Filter level",
    entry: "Level",
    options: ["Trace", "Debug", "Information", "Warning", "Error", "Critical"],
  },
];

const ToggleButtonChooser = ({ field, options, ...props }) => {
  const [val, setVal] = useFormField(field);
  return (
    <Button.Group {...props}>
      {options.map((v) => (
        <Button
          toggle
          active={val == v.value}
          onClick={() => setVal(v.value)}
          key={v.value}
        >
          {v.text}
        </Button>
      ))}
    </Button.Group>
  );
};

const LogModal = ({ as: As = Button, onSubmit, initialData, ...props }) => (
  <ModalBuilder
    withForm
    onSubmit={onSubmit}
    initialData={initialData}
    renderTrigger={(showModal) => <As onClick={showModal} {...props} />}
    renderModal={(modalProps, formProps) => (
      <Modal
        {...modalProps}
        header="View kibana logs"
        submitLabel="View"
        submitIcon="file alternate outline"
        className="logModal"
      >
        <Form {...formProps}>
          <Grid>
            {fields.map(({ ref, toggle, entry, options }) => (
              <React.Fragment key={ref}>
                <Grid.Column
                  computer={3}
                  tablet={4}
                  mobile={16}
                  key={"use" + ref}
                >
                  <Form.Field label={toggle} fluid>
                    <Form.Checkbox
                      field={"use" + ref[0].toUpperCase() + ref.substring(1)}
                      toggle
                    />
                  </Form.Field>
                </Grid.Column>
                <Grid.Column computer={5} tablet={12} mobile={16} key={ref}>
                  {options ? (
                    <Form.Dropdown
                      field={ref}
                      fluid
                      label={entry}
                      options={options.map((v) => ({ value: v, text: v }))}
                    />
                  ) : (
                    <Form.Input field={ref} fluid label={entry} />
                  )}
                </Grid.Column>
              </React.Fragment>
            ))}
            {Object.keys(initialData)
              .filter(
                (k) =>
                  !k.startsWith("use") &&
                  k.indexOf("|") != -1 &&
                  !fields.find((f) => f.ref == k)
              )
              .map((k) => (
                <React.Fragment key={k}>
                  <Grid.Column
                    computer={3}
                    tablet={4}
                    mobile={16}
                    key={"use" + k}
                  >
                    <Form.Field label="Filter scope" fluid>
                      <Form.Checkbox
                        field={"use" + k[0].toUpperCase() + k.substring(1)}
                        toggle
                      />
                    </Form.Field>
                  </Grid.Column>
                  <Grid.Column computer={5} tablet={12} mobile={16} key={k}>
                    <Form.Input
                      field={k}
                      fluid
                      label={k.substring(0, k.indexOf("|"))}
                    />
                  </Grid.Column>
                </React.Fragment>
              ))}
            <Form.Field label="Timeframe">
              <Grid.Column computer={8} tablet={16} mobile={16}>
                <ToggleButtonChooser
                  field="timeframe"
                  options={[
                    { value: "15m", text: "15m" },
                    { value: "1h", text: "1h" },
                    { value: "12h", text: "12h" },
                    { value: "24h", text: "24h" },
                    { value: "7d", text: "7d" },
                  ]}
                  basic
                />
              </Grid.Column>
            </Form.Field>
          </Grid>
        </Form>
      </Modal>
    )}
  />
);

export default LogModal;
